import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/Button';

type Props = {
  isOpen: boolean;
  authorName: string;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export default function CompaniesTimelineDeleteModal({
  isOpen,
  authorName,
  isPending,
  onCancel,
  onConfirm,
}: Props) {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onCancel();
      }}
    >
      <DialogContent className="w-[640px] max-w-full overflow-hidden rounded-sm shadow-layer3!">
        <DialogTitle className="border-b border-solid border-border px-lg py-md text-heading-xs! text-main">
          {authorName}のメッセージ
        </DialogTitle>
        <div className="p-lg">
          <p className="text-body-md text-black">メッセージを削除しますか？</p>
        </div>
        <div className="flex items-center justify-end gap-md border-t border-solid border-border px-lg py-md">
          <Button type="button" color="secondary" size="md" onClick={onCancel} disabled={isPending}>
            キャンセル
          </Button>
          <Button type="button" color="danger" size="md" onClick={onConfirm} disabled={isPending}>
            削除する
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
